import { render, staticRenderFns } from "./DetalheCampanhaWhatsapp.vue?vue&type=template&id=f7d74498&scoped=true"
import script from "./DetalheCampanhaWhatsapp.vue?vue&type=script&lang=js"
export * from "./DetalheCampanhaWhatsapp.vue?vue&type=script&lang=js"
import style0 from "./DetalheCampanhaWhatsapp.vue?vue&type=style&index=0&id=f7d74498&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d74498",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7d74498')) {
      api.createRecord('f7d74498', component.options)
    } else {
      api.reload('f7d74498', component.options)
    }
    module.hot.accept("./DetalheCampanhaWhatsapp.vue?vue&type=template&id=f7d74498&scoped=true", function () {
      api.rerender('f7d74498', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DetalheCampanhaWhatsapp.vue"
export default component.exports